module.exports = __webpack_public_path__ + "static/img19-ebd0673f5f29d811caee2419a0ded94f.jpg";